/**
 * Normalise a user-list reply to an array.
 *
 * Ergo's property line returns a dict keyed by index —
 * `{"0": {"user_id": "ergobaltic@camcom.ai"}}` from POST /useridList — where
 * the motor endpoint returns a list. No caller should have to know which.
 *
 * Lives here rather than in userService because that module reaches axios,
 * which Jest cannot transform in this project (see apiGeneration.js, kept
 * axios-free for the same reason) — and a shape normaliser is exactly the kind
 * of thing that needs a test.
 */
export const normaliseUserList = (payload) => {
  if (Array.isArray(payload)) return payload;
  if (payload && typeof payload === "object") {
    if (Array.isArray(payload.data)) return payload.data;
    return Object.values(payload).filter(
      (entry) => entry && typeof entry === "object",
    );
  }
  return [];
};

export default normaliseUserList;
